import React from "react"
import styled from "styled-components"

interface Props {
  required?: boolean
}

const Span = styled.span`
  &.require {
    background: #e01e1e;
    color: #ffffff;
    font-size: 14px;
    padding: 5px 15px;
    border-radius: 11px;
    margin-left: 10px;
  }
  &.optional {
    background: #8d96a9;
    color: #ffffff;
    font-size: 14px;
    padding: 5px 15px;
    border-radius: 11px;
    margin-left: 10px;
  }
`

export default function AcRequire(props: Props) {
  const { required = true } = props
  return <Span className={`${required ? "require" : "optional"}`}>{required ? "必須" : "任意"}</Span>
}
